<template>
  <b-form-group class="form-input" :label="label" :label-for="id">
    <b-form-input
      :placeholder="placeholder"
      :value="value"
      :id="id"
      @input="$emit('input', $event)"
      class="form-control rounded-pill"
      :class="{ 'error-border': errored, ...inputClass }"
      :type="type"
      :disabled="disabled"
      v-autofocus="!autoselect && autofocus"
      v-autoselect="autoselect"
      v-no-capture
      :autocomplete="autocomplete"
      :autocorrect="autocorrect"
      :autocapitalize="autocapitalize"
      :spellcheck="spellcheck"
    />
    <div class="field-error-message mt-1" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'FormInput',
  props: {
    placeholder: { type: String },
    value: { type: String },
    label: { type: String, default: '' },
    id: { type: String },
    errored: { type: Boolean, default: false },
    errorMessage: { type: String },
    type: { type: String, default: 'text' },
    autofocus: { type: Boolean, default: false },
    autoselect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    autocomplete: { type: String, default: undefined },
    autocorrect: { type: String, default: undefined },
    autocapitalize: { type: String, default: undefined },
    spellcheck: { type: String, default: '' },
    inputClass: { type: Object, default: () => {} }
  },
  components: {
    BFormInput,
    BFormGroup
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_errors.scss';
.field-error-message {
  padding-left: 12px;
}
.form-input /deep/ label {
  margin-left: 12px;
}
</style>
